import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {UnitModel} from './unit.model';
import {ReactiveServiceWithFilters} from '../reactive-service-with-filters.abstract';
import {forkJoin} from 'rxjs/internal/observable/forkJoin';

@Injectable()
export class UnitsApiService extends ReactiveServiceWithFilters implements Resolve<UnitModel[]> {
  protected baseUrl = environment.backEndUrlPrefix + '/db/unit';

  constructor(protected http: HttpClient) {
    super();
  }

  getAll() {
    return this.http.get<UnitModel[]>(this.buildUrl(this.baseUrl));
  }

  updateGroup(ids: number[], data): Observable<UnitModel[]> {
    return this.http.patch<UnitModel[]>(environment.backEndUrlPrefix + '/db/unit', data, {params: {id: ids.map(id => id.toString())}});
  }

  deleteGroup(ids: number[]): Observable<string> {
    return this.http.delete<string>(this.baseUrl, {params: {id: ids.map(id => String(id))}});
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UnitModel[]> | Promise<UnitModel[]> | UnitModel[] {
    return this.getAll();
  }


}

